import { render } from "./NewNavBar.vue?vue&type=template&id=519c0c89&scoped=true"
import script from "./NewNavBar.vue?vue&type=script&lang=js"
export * from "./NewNavBar.vue?vue&type=script&lang=js"

import "./NewNavBar.vue?vue&type=style&index=0&id=519c0c89&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519c0c89"]])

export default __exports__